/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDomainIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-domain"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M0.15 20.3L0.15 3.7Q0.15 2.58 0.91 1.81Q1.68 1.05 2.8 1.05L9.75 1.05Q10.88 1.05 11.64 1.81Q12.4 2.58 12.4 3.7L12.4 5.85L21.2 5.85Q22.32 5.85 23.09 6.61Q23.85 7.38 23.85 8.5L23.85 20.3Q23.85 21.43 23.09 22.19Q22.32 22.95 21.2 22.95L2.8 22.95Q1.68 22.95 0.91 22.19Q0.15 21.43 0.15 20.3ZM2.8 20.3L4.95 20.3L4.95 18.15L2.8 18.15ZM2.8 15.5L4.95 15.5L4.95 13.35L2.8 13.35ZM2.8 10.65L4.95 10.65L4.95 8.5L2.8 8.5ZM2.8 5.85L4.95 5.85L4.95 3.7L2.8 3.7ZM7.6 20.3L9.75 20.3L9.75 18.15L7.6 18.15ZM7.6 15.5L9.75 15.5L9.75 13.35L7.6 13.35ZM7.6 10.65L9.75 10.65L9.75 8.5L7.6 8.5ZM7.6 5.85L9.75 5.85L9.75 3.7L7.6 3.7ZM12.4 20.3L21.2 20.3L21.2 8.5L12.4 8.5L12.4 10.65L14.55 10.65L14.55 13.3L12.4 13.3L12.4 15.5L14.55 15.5L14.55 18.15L12.4 18.15ZM16.5 13.3L16.5 10.65L19.15 10.65L19.15 13.3ZM16.5 18.15L16.5 15.5L19.15 15.5L19.15 18.15Z" fill={color} />
    </svg>
  );
}
